import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7aa5be20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "album__header" }
const _hoisted_2 = { class: "album__header-content" }
const _hoisted_3 = { class: "album__header-tabs" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "album__header-operations"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opera-label" }, "取消选择", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "opera-icon" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opera-label" }, "下载", -1))
const _hoisted_10 = { class: "opera-icon" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opera-label" }, "删除", -1))
const _hoisted_12 = {
  key: 1,
  class: "album__header-operations"
}
const _hoisted_13 = { class: "opera-icon" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opera-label" }, "刷新", -1))
const _hoisted_15 = { class: "opera-icon" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "opera-label" }, "来源管理", -1))

import { PropType, reactive, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import SVGIcon from '@remote/components/SVGIcon.vue'
import { useAlbumStore } from '@remote/store/album'
import { checkState } from '@remote/store/utils'
import { isLargeViewPort } from '@remote/utils/base'
import Modal from '@remote/components/modal'


export default /*#__PURE__*/_defineComponent({
  props: {
  slides: {
    type: Array as PropType<Readonly<{ title: string; id: string }[]>>,
    required: true,
  },
  currentSlideIndex: {
    type: Number,
    default: 0,
  },
  inSubPath: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:currentSlideIndex'],
  setup(__props, { emit }) {

const props = __props





const {
  data,
  refresh,
  subPathData,
  selectTab: selectCurrentTab,
  cancelSelectedAll,
  deletePhotos,
  downloadPhotos,
} = useAlbumStore()

const router = useRouter()

const selectTab = (index: number) => {
  selectCurrentTab(index)
  emit('update:currentSlideIndex', index)
}

const refreshRef = reactive({
  isRefreshing: false,
  lastTime: 0,
})

const hasSeleted = computed(() => {
  const dataSource = props.inSubPath ? subPathData : data
  return !!Object.keys(dataSource.selectedMap).length
})

const isScraping = computed(() => {
  if (data.isRefresh) return true
  return isLargeViewPort() ? refreshRef.isRefreshing : false
})

function onRefresh () {
  if (isScraping.value) return
  if (checkState(true, true, true, false)) return
  refreshRef.isRefreshing = true
  refreshRef.lastTime = Date.now()
  refresh()
}

function onDelete () {
  const onOk = ():Promise<string|null> => deletePhotos()
  Modal.Delete({
    title: '确定删除所选照片吗？',
    cancelText: '取消',
    okText: '删除',
    loadingText: '删除中...',
    hasCheck: false,
    onOk,
  })
}

watch(() => data.isRefresh, (isScraping) => {
  console.log('isScraping', isScraping)
  if (!isScraping) {
    const now = Date.now()
    const duration = now - refreshRef.lastTime
    if (duration > 3000) {
      refreshRef.isRefreshing = false
    } else {
      setTimeout(() => {
        refreshRef.isRefreshing = false
      }, 3000 - duration)
    }
  }
})

function gotoScrapeSettingPage () {
  const isPC = isLargeViewPort()
  if (!isPC) {
    router.push({
      name: 'scrapeSettings',
    })
  } else {
    // 刮削设置弹窗
    Modal.showAlbumPathSettingModal({ mask: true })
  }
}

function goback () {
  router.go(-1)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.inSubPath)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("i", {
                class: "back",
                onClick: goback
              }),
              _createElementVNode("span", {
                class: "album__header-tab is-active",
                onClick: goback
              }, _toDisplayString(_unref(subPathData).title), 1)
            ], 64))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.slides, (slide, index) => {
              return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["album__header-tab", {
              'is-active': index === __props.currentSlideIndex,
            }]),
                key: slide.title,
                onClick: ($event: any) => (selectTab(index))
              }, _toDisplayString(slide.title), 11, _hoisted_4))
            }), 128))
      ]),
      (_unref(hasSeleted))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "opera-item",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(cancelSelectedAll) && _unref(cancelSelectedAll)(...args)))
            }, _hoisted_7),
            _createElementVNode("div", {
              class: _normalizeClass(["opera-item opera-btn", { 'is-refreshing': _unref(isScraping) }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(downloadPhotos)()))
            }, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(SVGIcon, { name: "download" })
              ]),
              _hoisted_9
            ], 2),
            _createElementVNode("div", {
              class: "opera-item opera-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (onDelete()))
            }, [
              _createElementVNode("span", _hoisted_10, [
                _createVNode(SVGIcon, { name: "del" })
              ]),
              _hoisted_11
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass(["opera-item opera-btn refresh-btn", { 'is-refreshing': _unref(isScraping) }]),
              onClick: onRefresh
            }, [
              _createElementVNode("span", _hoisted_13, [
                _createVNode(SVGIcon, { name: "refresh" })
              ]),
              _hoisted_14
            ], 2),
            _createElementVNode("div", {
              class: "opera-item opera-btn setting-btn",
              onClick: gotoScrapeSettingPage
            }, [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(SVGIcon, { name: "setting" })
              ]),
              _hoisted_16
            ])
          ]))
    ])
  ]))
}
}

})